import { defineMessages } from 'react-intl.macro';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { cobraLogout } from '@tmapy/auth';
import { AppState, useDispatch } from '@tmapy/redux';
import { SecondaryBtn } from '@tmapy/style-guide';

import { useAuth, useSelector } from '../../hooks';
import { twistLogout } from '../actions';

const msg = defineMessages({
  logout: {
    id: 'auth.logout.button',
    defaultMessage: 'Odhlásit',
  },
});

export const LogoutBtn: React.FC = React.memo(() => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const { auth: authConfig } = useSelector((state: AppState) => state.app.config);

  const handleClick = () => {
    if (authConfig) {
      cobraLogout();
      return;
    } else {
      dispatch(twistLogout());
    }
  };

  return auth.isAuthenticated || auth.access_token ? (
    <SecondaryBtn onClick={handleClick} isDanger>
      <FormattedMessage {...msg.logout} />
    </SecondaryBtn>
  ) : null;
});
